module.exports = __webpack_public_path__ + "img/第1章_3-2_南山寺奇異照片.jpg";